import { customFieldsPayload } from "components/BaseForm";

/**
 * Form values as the argument of `CampaignService.createCampaign` and
 * `editCampaign`. The two methods name the assignee and the times differently,
 * so `campaignId` selects the edit shape.
 */
export const toCampaignPayload = (
  values,
  { customFieldConfigs, campaignId }
) => {
  const shared = {
    name: values.name.trim(),
    status: values.status,
    // The DTO types region_id and form_id as non-nullable integers, so a
    // cleared value has to drop the key rather than send null.
    region: values.region_id || undefined,
    form: values.form_id || undefined,
    emailService: values.email_service,
    emailType: values.email_type,
    description: values.description.trim(),
    emailTemplates: values.limit_email_templates ? values.email_templates : [],
    custom: customFieldsPayload(customFieldConfigs, values.custom_fields),
    campaignStatusPreset: values.campaign_status_preset || null,
    caseCampaignStatusPreset: values.case_campaign_status_preset || null,
    revenueStatusPreset: values.revenue_status_preset || null,
    revenueRecipientPreset: values.revenue_recipient_preset || null,
  };

  return campaignId != null
    ? {
        ...shared,
        campaignId,
        assigned: values.assigned_user_id,
        start: values.start_time,
        end: values.end_time || null,
      }
    : {
        ...shared,
        assigned_user_id: values.assigned_user_id,
        start_time: values.start_time,
        end_time: values.end_time || null,
      };
};
